export default __webpack_public_path__ + "static/media/minus.58e5a1af.svg";